import { render, staticRenderFns } from "./ChangePolicyFormSuccess.vue?vue&type=template&id=0351d4cf&scoped=true"
import script from "./ChangePolicyFormSuccess.vue?vue&type=script&lang=js"
export * from "./ChangePolicyFormSuccess.vue?vue&type=script&lang=js"
import style0 from "./ChangePolicyFormSuccess.vue?vue&type=style&index=0&id=0351d4cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351d4cf",
  null
  
)

export default component.exports